<template>
  <button
    @click="onClick"
    :class="{ disabled }"
    :disabled="disabled"
    class="action-button"
  >
    <slot></slot>
    <spinner v-if="busy"></spinner>
  </button>
</template>

<style lang="less" scoped>
.action-button {
  padding: 8px 20px 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  background-color: orange;
  color: white;
  white-space: nowrap;

  &:not(.disabled):hover {
    background: #222222;
  }

  &.disabled {
    background-color: #666 !important;
    cursor: default;
  }

  .spinner {
    height: 17px;
    width: 17px;
    margin-left: 5px;
    transform: translateY(3px);

    /deep/ .spin-element {
      border-width: 3px;
    }
  }
}
</style>

<script>
import Spinner from "@/common/components/Spinner";

export default {
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick(event) {
      if (!this.busy && !this.disabled) {
        this.$emit('click', event);
      }
      this.$el.blur();
    },
  },
  components: { Spinner },
};
</script>
